import * as React from "react";
import CountUp from "react-countup";
import styled from "styled-components";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";

/** AchievementsCounterBlockElementData */
interface AchievementsCounterBlockElementData {
  /** UNICODE IKONKI => https://material.io/icons/, NP: keyboard */
  iconString: string

  /** ODLICZANIE => LICZBA OD KTÓREJ STARTUJE */
  counterStart: number

  /** ODLICZANIE => LICZBA NA KTÓREJ SIĘ KOŃCZY */
  counterEnd: number

  /** ODLICZANIE => CZAS ODLICZANIA W SEKUNDACH */
  counterDuration: number

  /** TEKST => SZARY TEKST POD LICZBĄ */
  counterText: string
}

/** AchievementsCounterBlockElement */
interface AchievementsCounterBlockElementProps extends AchievementsCounterBlockElementData {
  /** INFORMACJA CZY COUNTER JEST GOTOWY DO ODLICZANIA */
  counterReady: boolean
}

const AchievementsCounterBlockElement = (props: AchievementsCounterBlockElementProps) => {
  const {iconString,counterStart,counterEnd,counterDuration,counterText,counterReady} = props;
  return (
    <CounterWrapper className="col-sm-6 col-md-6 col-lg-4">
      <ShadowEffectWrapper>
        <i className="material-icons brand-color" style={{fontSize: '50px'}}>{iconString}</i>
        <span className="timer">
          {counterReady ? <CountUp start={counterStart} end={counterEnd} duration={counterDuration} /> : <span>{counterEnd}</span>}
        </span>
        <span className="count-description">{counterText}</span>
      </ShadowEffectWrapper>
    </CounterWrapper>
  )
};

/** STYLES => AchievementsCounterBlockElement */

const CounterWrapper = styled.div`
  padding: 15px 0 !important;
  span.timer {
    font-size: 60px !important;
  }
`;

const ShadowEffectWrapper = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  margin: 0 10px;
`;

/** AchievementsCounterBlock */
interface AchievementsCounterBlockProps {
  /** ODLICZNIKI => NAJLEPIEJ WRZUCAĆ DOKŁADNIE 4 */
  counters: AchievementsCounterBlockElementData[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType
}

interface AchievementsCounterBlockState {
  countersReady: boolean
}

class AchievementsCounterBlock extends React.Component<AchievementsCounterBlockProps,AchievementsCounterBlockState> {

  constructor(props: AchievementsCounterBlockProps) {
    super(props);
    this.state = {
      countersReady: false
    };
    this.onComponentView = this.onComponentView.bind(this);
  }

  onComponentView() {
    // ODLICZNIKI
    this.setState({countersReady: true});

    // GOOGLE EVENT
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  render() {
    const {counters} = this.props;
    const {countersReady} = this.state;
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <AchievementsCounterBlockWrapper className="facts-two">
          <AchievementsCounterContainerWrapper className="container">
            <div className="row text-center">
              {counters.map((counter: AchievementsCounterBlockElementData, index: number) =>
                <AchievementsCounterBlockElement
                  key={index}
                  {...counter}
                  counterReady={countersReady}
                />
              )}
            </div>
          </AchievementsCounterContainerWrapper>
        </AchievementsCounterBlockWrapper>
      </div>
    )
  }

}

/** STYLES => AchievementsCounterBlock */

const AchievementsCounterBlockWrapper = styled.section`
  margin-top: -20px;
  padding-bottom: 70px;
`;

const AchievementsCounterContainerWrapper = styled.div`
  width: 100% !important;
`;

export default AchievementsCounterBlock


// WEBPACK FOOTER //
// ./src/layouts/achievements-counter-block/achievements-counter-block.tsx